// extracted by mini-css-extract-plugin
export var postAuthor = "style-module--post-author--92f26";
export var postAuthor__description = "style-module--post-author__description--d4d2f";
export var postAuthor__desk = "style-module--post-author__desk--309b6";
export var postAuthor__head = "style-module--post-author__head--eb76a";
export var postAuthor__headSimple = "style-module--post-author__headSimple--e45ca";
export var postAuthor__icon = "style-module--post-author__icon--058e7";
export var postAuthor__image = "style-module--post-author__image--aaa55";
export var postAuthor__imageSimple = "style-module--post-author__imageSimple--75e70";
export var postAuthor__info = "style-module--post-author__info--432bb";
export var postAuthor__infoSimple = "style-module--post-author__infoSimple--2267a";
export var postAuthor__links = "style-module--post-author__links--dbebd";
export var postAuthor__socials = "style-module--post-author__socials--01a4d";
export var postAuthor__socialsDesk = "style-module--post-author__socials-desk--b5ba1";
export var postAuthor__socialsSimple = "style-module--post-author__socialsSimple--99960";